<template>
    <v-container>
        <v-card border elevation="10" class="mx-auto pa-4" max-width="400" >
            <v-card-title class="text-h5 text-center"><h1 class="text-h5 font-weight-regular">Set up authenticator app MFA</h1></v-card-title>
            <v-card-text>Complete the process with the code in your authenticator app to set up the MFA and sign-in.</v-card-text>
            <section>
                <div class="d-flex py-3">
                    <div class="flex-grow-1 min-width-0 mr-6">
                        <h2 class="text-h6">1. Install App</h2>
                        <p class="text-wrap" style="max-width: 300px;">
                                Install an authenticator app on your mobile device.
                        </p>
                    </div>
                    <v-icon
                        size="100"
                        aria-hidden="true"
                    >
                        mdi-cellphone-information
                    </v-icon>
            </div>
            <div class="d-flex py-3">
                <div class="flex-grow-1 min-width-0 mr-6">
                    <h2 class="text-h6"> 2. Scan QR code</h2>
                     <p class="text-wrap pb-5" style="max-width: 200px;">
                            Scan the QR code with your authenticator app.
                        </p>
                        <p class="text-wrap" style="max-width: 200px;">
                            Secret Key: {{SecretCode}}
                        </p>
                </div>
                
                <QRCode :value="authlink" :size=100 render-as="svg"></QRCode>
            </div>

            <div class="py-3">
       <h2 class="text-h6">3. Enter Code</h2>  
                
                 <v-text-field autofocus rounded v-model="mfaSetUpCode" aria-label="Enter Code" label="Enter Code" required></v-text-field>
            </div>
           
            </section>    
            <div class="d-flex flex-column ga-5">
                <v-btn rounded block elevation="1" border @click="setUpMFAApp">sign in</v-btn>
        
            <v-btn rounded block elevation="1" border @click="logout">Go Back</v-btn>
            </div>
            
        </v-card>
    </v-container>
</template>

<script setup>
  import {ref} from 'vue'
  import { useRoute ,useRouter } from 'vue-router'
  import { usePathController } from '@/composables/usePathController'
  import {useEntityRoute} from '@/composables/route/useListViewRoute'
  import QRCode from 'qrcode.vue'
  import {useLogger} from '@/composables/useLogger'
  const {sendLog} = useLogger()
  const router = useRouter()
  const queryValue = useEntityRoute()
  import { useUserStore } from '@/store/user'
  const {goTo, logoutCoordinator, followRedirection} = usePathController()
  const userStore = useUserStore()
  const mfaSetUpCode = ref("")

  const accessToken = queryValue?.accessToken?.value || userStore.challengeMetadataBody?.accessToken
  const SecretCode = queryValue?.SecretCode?.value || userStore.challengeMetadataBody?.SecretCode
  const authlink = queryValue?.authlink?.value || userStore.challengeMetadataBody?.authlink

  const setUpMFAApp = async () => {
    sendLog("debug", "set_up_MFA_api_is_called", { 
        redirectSubsystem: queryValue?.redirectSubsystem?.value,
        landingPath: queryValue?.landingPath?.value,
    })

    const response = await userStore.setupMFAAPP({  
        accessToken: accessToken,
        userCode: mfaSetUpCode.value,
        redirectSubsystem: queryValue?.redirectSubsystem?.value,
        landingPath: queryValue?.landingPath?.value,
    })
    followRedirection(response)
}
  const logout = async () => {
    logoutCoordinator()
    goTo("/login")
  } 
</script> 